import React from 'react';
import CardSlider from '../UI/CardSlider';
import './Slider.css';
import cryptoverse from '../assets/cryptoverse.png';
import wheels from '../assets/wheels2.jpeg';
import money from '../assets/money1.jpeg';
import beFriend from '../assets/be-friend1.jpeg';
import rentCar from '../assets/rent-car2.jpeg';
import marketX from '../assets/marketX.jpeg';
import market from '../assets/market.jpeg';
import indemnMariaj from '../assets/indemn-mariaj1.png';

const Slider = () => {

    const cardsData = [
        { id: 1, title: 'Cryptoverse', content: 'Keep up to date with the latest information', imgUrl: cryptoverse },
        { id: 2, title: 'Wheels Performance', content: 'Super stylish wheels for powerful cars', imgUrl: wheels },
        { id: 3, title: 'Money Management', content: 'Manage your money quickly and efficiently', imgUrl: money },
        { id: 4, title: 'Be Friends', content: 'The best social network to find the right friends', imgUrl: beFriend },
        { id: 5, title: 'My Rent', content: 'Rent any car at the best price directly from the owner', imgUrl: rentCar },
        { id: 6, title: 'MarketX', content: 'Grow your business as a spaceship takes off', imgUrl: marketX },
        { id: 7, title: 'Market', content: 'Here you can find all kinds of things at great prices', imgUrl: market },
        { id: 8, title: 'Indemn Mariaj', content: 'Print the beautiful moments of your life', imgUrl: indemnMariaj },
    ]

    return (
        <div className="container-slider">
            <div className="cards-container">
                {
                    cardsData.map((card) => (
                        <CardSlider title={card.title}
                            content={card.content}
                            imgUrl={card.imgUrl} />
                    ))
                }
            </div>
        </div>
    )
}

export default Slider